import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphEventsUpcoming as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphEventsUpcomingProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphEventsUpcoming: React.FC<ParagraphEventsUpcomingProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;
  const showAllOccurrences = paragraph.field_show_recurrences[0]?.value;

  return (
    <div className="Paragraph ParagraphEventsUpcoming">
      {title && (
        <h2>{title}</h2>
      )}
      {body && (
        <WysiwygField
          html={body}
          classes="ParagraphEventsUpcoming__body"
        />
      )}
      <View
        id="events"
        display="upcoming"
        showAllOccurrences={showAllOccurrences}
      />
    </div>
  );
};

export default ParagraphEventsUpcoming;
